import { rest } from 'msw'

export default [
  /**
   * 業種区分情報
   */
  rest.get('/swc-api/master/industry-types', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([
        {
            "code": "aqueduct",
            "name": "用水処理"
        },
        {
            "code": "drainage",
            "name": "排水処理"
        },
        {
            "code": "precipitation",
            "name": "最初沈澱池"
        },
        {
            "code": "sludge",
            "name": "活性汚泥"
        },
        {
            "code": "dehydration",
            "name": "脱水"
        },
        {
            "code": "outside",
            "name": "場外"
        },
        {
            "code": "mobile_dehydration",
            "name": "移動脱水車"
        }
    ]),
    )
  }),
]
